<!-- NOTE: the stickyWrapperClass="mb-2" is added on the <wl-receipt> to match the mb-2 of the last order-step -->
@if (viewModel$ | async; as vm) {
  <wl-receipt
    [title]="
      rendering.fields.Title.value
        | interpolate
          : {
              variables: {
                savings:
                  vm.maxYearlySavings | currency: 'EUR' : 'symbol' : '1.0-0',
              },
            }
    "
    [sticky]="true"
    stickyWrapperClass="mb-2"
    [wlTrackProduct]="{
      rendering: rendering,
      track: vm.selectedProducts,
      trackingConfig: trackProductConfig,
      trackMode: 'product-detail',
    }"
  >
    <ng-template wlReceiptBreakdown>
      @for (product of vm.selectedProducts; track product; let i = $index) {
        <wl-receipt-breakdown-row [separator]="true" [hasRightPart]="false">
          <ng-container leftProjection>
            <p class="receipt-product-title h4 mb-1">
              {{ product.content.title }}
            </p>
            <wl-generic-usps
              [usps]="formattedSavings(product)"
            ></wl-generic-usps>
          </ng-container>
        </wl-receipt-breakdown-row>
      }
    </ng-template>
    @if (vm.unsuitableProducts.length) {
      <ng-template wlReceiptConclusion>
        <wl-receipt-breakdown-row [hasRightPart]="false">
          <ng-container leftProjection>
            <div
              *wlGenericRichText="
                formatUnsuitableDisclaimer(
                  vm.unsuitableProducts,
                  'Or' | translate
                )
              "
            ></div>
          </ng-container>
        </wl-receipt-breakdown-row>
      </ng-template>
    }
  </wl-receipt>
}
